import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { FormArray, FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { TIMEZONE_ZONES, TimezoneOption } from '../utils/timezone-zones.constant';
import { Router, NavigationEnd } from '@angular/router';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { LeadStatusService } from 'src/app/services/lead-status.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { SimpleDynamicFormComponent } from '../simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { DynamicFieldValueService } from 'src/app/services/dynamic-field-value.service';
import { DOCUMENT, DatePipe, CommonModule } from '@angular/common';
import { WhatsapptemplatemessageService } from 'src/app/services/whatsapptemplatemessage.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { GoogleMapService } from 'src/app/services/google-map.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DirectiveModule } from '../directive/directive.module';
import { SimpleDynamicComponentModule } from '../simple-form/simple-dynamic-component.module';
import { ProductModule } from 'src/app/pages/catalog/product/product.module';
import { LoaderModule } from 'src/app/pages/loader/loader.module';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { CallOutcomeService } from 'src/app/services/call-outcome.service';

declare var google: any;
@Component({
    selector: 'calsoft-conversation-popup',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatMomentDateModule,
        NgxMatSelectSearchModule,
        DirectiveModule,
        SimpleDynamicComponentModule,
        ProductModule,
        LoaderModule,
        CustomFlexLayoutModule
    ],
    templateUrl: './conversation-popup.component.html',
    styleUrls: ['./conversation-popup.component.scss']
})
export class ConversationPopupComponent implements OnInit, OnDestroy {

    sanitizedUrl: string = '';


    url = '';

    @ViewChild(SimpleDynamicFormComponent, { static: false })
    simpleDynamicFormComponent:
        SimpleDynamicFormComponent;
    firstFormGroup: UntypedFormGroup;

    showActivityDetailsSection: boolean = true;
    showAddTaskSection: boolean = false;
    id: any;
    text: string;
    data: any;
    type: any = 1;
    activityId: number;
    textmap: string;

    activityType: any;

    regConfig: any[] = [];

    init: boolean = false;
    simpleFormValueList: any = [];
    originalValue: any;
    apiKey: any;
    initNotes: boolean = false;
    taskType: any;
    followUpNewTime: any;
    dueTime: any;
    displayNewline: boolean = false;
    callNotesEnable: any = 0;
    durarationVisible: boolean = false;
    callTriger: any = 0;

    constructor(
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) data,
        private _formBuilder: UntypedFormBuilder,
        private snackBar: MatSnackBar,
        private dynamicFormLabelService: DynamicFormLabelService,
        private dialogRef: MatDialogRef<ConversationPopupComponent>,
        private leadActivityService: LeadActivityService,
        private leadStatusService: LeadStatusService,
        private dynamicFieldValueService: DynamicFieldValueService,
        private whatsapptemplatemessageService: WhatsapptemplatemessageService,
        private datePipe: DatePipe,
        private elRef: ElementRef, private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        private ecryptService: EcryptServiceService,
        private loaderService: LoaderService,
        private cdr: ChangeDetectorRef,
        public googleMapService: GoogleMapService,
        private callOutcomeService: CallOutcomeService,
        private router: Router,
    ) {

        this.data = data;
        this.url = this.router.url || '';
        this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
    }


    today: Date = new Date();

    time = new Date();

    enableLocation: any;

    activityTypeList: any;

    ngOnInit(): void {

        if (this.data.taskType == 3) {

            this.taskType = 3;
        }

        if (this.router.url == 'lead') {
            this.displayNewline = true;
        } else {
            this.displayNewline = true;
        }

        this.getCallOutcomeDropDownList();
        this.typeCallOutcomeYFilter();

        this.getConfigData();
        this.getAllCrmData();

        this.text = "Save";
        this.textmap = "Get Current Location";
        this.initActivity();

        this.getLeadDropDownList();
        this.getAlldropdowntype();
        this.typeYFilter();

        this.firstFormGroup.get("activityType").setValue(this.data['activityType']);

        this.firstFormGroup.get("leadId").setValue(this.data['leadId']);

        this.type = this.data.type;

        console.log(this.data, "data");

        this.activityId = this.data.activityId;

        this.activityType = this.data.activityType;

        this.callNotesEnable = this.data.callnoteEnable;

        this.callTriger = this.data.callTriger;

        if (this.activityType == 'patch') {

            this.firstFormGroup.get("previousActivityId").setValue(this.data['leadObject'].id);

        } else {
            this.firstFormGroup.get("previousActivityId").setValue(0);

        }


        if (this.activityType == 'Edit') {

            this.editlead(this.data.leadObject);
            this.firstFormGroup.get('dueDate')?.disable();
            this.firstFormGroup.get('dueTime')?.disable();
            this.firstFormGroup.get('reminder')?.disable();
        } else {
            this.firstFormGroup.patchValue({
                taskType: this.data.taskSaveType
            });
        }

        this.getWhatsappTemplateMessageList();
        this.WhatsappTemplateMessageYFilter();




        if (this.activityType != 'Edit') {
            if (this.taskType == 2 && this.activityId == 0) {
                const now = new Date();

                // add 30 minutes (30 * 60 * 1000 ms)
                const plus30 = new Date(now.getTime() + 30 * 60000);

                const currentDate = plus30.toISOString().split('T')[0];   // yyyy-MM-dd
                const currentTime = plus30.toTimeString().slice(0, 5);     // HH:mm

                this.firstFormGroup.get('dueDate')?.setValue(currentDate);
                this.firstFormGroup.get('dueTime')?.setValue(currentTime);
            }
        }

        if (this.taskType != 4 && this.taskType != 5) {
            if (this.activityId == 0 && this.firstFormGroup.controls.activityType.value == 'Phone Call' && this.taskType != 4) {

                this.firstFormGroup.get('callOutcome')?.setValue('No Answer');

                this.firstFormGroup.get('phoneCallOutcome')?.setValue('Completed');

            }

            this.activityTypeList = [
                { value: "Phone Call", viewValue: "Phone Call" },
                { value: "Follow Up", viewValue: "Follow Up" },
                { value: "Call reminder", viewValue: "Call reminder" },
                { value: "Location", viewValue: "Location" },
                { value: "Connected", viewValue: "Connected" },
                { value: "Not Connected", viewValue: "Not Connected" },
                { value: "meeting", viewValue: "Meeting" },
            ]


        } else {

            if (this.taskType == 4 || this.taskType == 5) {

                if (this.firstFormGroup.controls.activityType.value == 'Follow Up') {

                    this.firstFormGroup.get('phoneCallOutcome')?.setValue('Followup');

                } else if (this.firstFormGroup.controls.activityType.value == 'Phone Call') {

                    this.firstFormGroup.get('phoneCallOutcome')?.setValue('Pending');

                    if (this.firstFormGroup.value.dueDate == null) {

                        const now = new Date();

                        const plus30 = new Date(now.getTime() + 30 * 60000);

                        const currentDate = plus30.toISOString().split('T')[0];
                        const currentTime = plus30.toTimeString().slice(0, 5);

                        this.firstFormGroup.get('dueDate')?.setValue(currentDate);
                        // this.firstFormGroup.get('dueTime')?.setValue(currentTime);

                    }

                }

                if (this.callTriger == 1) {

                    this.firstFormGroup.patchValue({
                        status: 0
                    })
                }

            } else {

                if (this.activityId == 0 && this.firstFormGroup.controls.activityType.value == 'Follow Up') {

                    this.firstFormGroup.get('callOutcome')?.setValue('No Answer');

                    this.firstFormGroup.get('phoneCallOutcome')?.setValue('Followup');

                } else if (this.activityId == 0 && this.firstFormGroup.controls.activityType.value == 'Phone Call') {

                    this.firstFormGroup.get('callOutcome')?.setValue('No Answer');

                    this.firstFormGroup.get('phoneCallOutcome')?.setValue('Pending');

                }

            }


            this.activityTypeList = [
                { value: "Phone Call", viewValue: "Phone Call" },
                { value: "Follow Up", viewValue: "Follow Up" },
            ]

        }



    }


    getAllCrmData() {
        const encryptedData = localStorage.getItem('crmSettingsData');
        if (encryptedData) {
            try {
                const decrypted = this.ecryptService.decryptionAES(encryptedData);
                const data = JSON.parse(decrypted);


                if (data != null) {

                    this.enableLocation = data['enableLocation'];
                    if (this.taskType != 3) {
                        this.taskType = data['taskType'] || 1;
                    }

                } else {
                    this.enableLocation = 0;
                    if (this.taskType != 3) {
                        this.taskType = data['taskType'] || 1;
                    }
                }


            }
            catch (error) {
                console.error("Failed to decrypt crmSettingsData:", error);
            }
        }
    }


    initActivity() {
        this.firstFormGroup = this._formBuilder.group({
            id: [0],
            notes: [''],
            createdDate: [''],
            updatedDate: [''],
            owner: [''],
            ownerId: [''],
            phoneCallOutcome: ['0'],
            leadId: [''],
            typeAndTime: ['0.0'],
            subject: [''],
            // conditionalValidator(
            //     (() => this.taskType > 2),
            //     Validators.required
            // )],
            schedule: [''],
            reminder: [''],
            description: [''],
            activityType: ['0'],
            activityIcon: [''],
            status: [0],
            followupDate: [''],
            followupTime: [''],
            timeZone: ['IST'],
            nextAction: ['0'],
            reminderMessage: [''],
            type: [''],
            typeMessage: [''],
            salesPerson: [''],
            customerAddress: [''],
            updatedBy: [''],
            previousActivityId: [0],
            followUpDateTime: [''],
            customerName: [''],
            templateId: [],
            lastStatusUpdatedDate: [''],
            lat: [''],
            longitutde: [''],
            scheduledDate: [''],
            scheduledDateTime: [''],
            startDateTime: [''],
            endDateTime: [''],
            isCompleted: [''],
            callType: [''],
            dueDate: ['', Validators.required],
            dueTime: ['', Validators.required],
            taskType: [''],
            saveType: [1],
            completedDate: [''],
            completedTime: [''],
            dueDateTime: [''],
            dynamicFieldValues: new FormArray([]),
            operationType: [''],
            leadTransferMessage: [''],
            callMessage: [''],
            callOutcome: ['No Answer'],
            automated: [0],
            sequenceId: [],
            stepId: [],
            taskId: [],
            step: [],
            mailSequenceId: [],


        });

        this.onChanges();
    }


    onChanges(): void {
        this.firstFormGroup.get('phoneCallOutcome')?.valueChanges.subscribe(val => {
            const isCompleted = val && (
                String(val).toLowerCase() === 'completed' ||
                String(val).toLowerCase() === 'complete'
            );
            if (this.taskType == 1) {
                if (val === 'Followup' || val === 'Demo' || val === 'Payment Followup') {
                    this.firstFormGroup.get('followupDate')?.setValidators([Validators.required]);
                    this.firstFormGroup.get('followupTime')?.setValidators([Validators.required]);
                } else {
                    this.firstFormGroup.get('followupDate')?.clearValidators();
                    this.firstFormGroup.get('followupTime')?.clearValidators();
                }
                this.firstFormGroup.get('dueDate')?.clearValidators();
                this.firstFormGroup.get('dueTime')?.clearValidators();
            } else if (val === 'Followup' || val === 'Demo' || val === 'Payment Followup') {
                this.firstFormGroup.get('followupDate')?.setValidators([Validators.required]);
                this.firstFormGroup.get('followupTime')?.setValidators([Validators.required]);
                this.firstFormGroup.get('dueDate')?.setValidators([Validators.required]);
                this.firstFormGroup.get('dueTime')?.setValidators([Validators.required]);
            } else {
                this.firstFormGroup.get('followupDate')?.clearValidators();
                this.firstFormGroup.get('followupTime')?.clearValidators();
                this.firstFormGroup.get('dueDate')?.clearValidators();
                this.firstFormGroup.get('dueTime')?.clearValidators();
            }

            if (isCompleted || this.taskType == 3) {
                this.firstFormGroup.get('dueDate')?.clearValidators();
                this.firstFormGroup.get('dueTime')?.clearValidators();
                this.firstFormGroup.get('followupDate')?.clearValidators();
                this.firstFormGroup.get('followupTime')?.clearValidators();
            }

            this.firstFormGroup.get('followupDate')?.updateValueAndValidity();
            this.firstFormGroup.get('followupTime')?.updateValueAndValidity();
            this.firstFormGroup.get('dueDate')?.updateValueAndValidity();
            this.firstFormGroup.get('dueTime')?.updateValueAndValidity();
        });
    }

    onCallOutcomeChange(event: any) {
        try {
            const val = event && event.value !== undefined ? event.value : event;
            const activityTypeVal = this.firstFormGroup.get('activityType')?.value;
            // Show Duration input when outcome contains 'connected' and activity is a new Phone Call
            if (String(activityTypeVal) === 'Phone Call' && val.includes('Connected')) {
                this.durarationVisible = true;

            } else {
                // hide duration for other cases
                this.durarationVisible = false;
            }
            // Trigger change detection if needed
            try { this.cdr.detectChanges(); } catch (e) { }
        } catch (e) { /* swallow errors */ }
    }

    @ViewChild('myTimeInput') myTimeInput: ElementRef;
    editlead(lead: any) {
        this.originalValue = lead.followupTime;
        this.firstFormGroup = this._formBuilder.group({
            id: lead.id || lead.activityId,
            notes: lead.notes,
            createdDate: lead.createdDate,
            updatedDate: lead.updatedDate,
            owner: lead.owner,
            ownerId: lead.ownerId,
            phoneCallOutcome: lead.phoneCallOutcome || lead.callOutcome,
            leadId: lead.leadId,
            typeAndTime: lead.typeAndTime,
            subject: lead.subject,
            schedule: lead.schedule,
            reminder: lead.reminder,
            description: lead.description,
            // activityType: lead.activityType,
            activityType: lead.activityType === 'OutboundCall' ? 'Phone Call' : lead.activityType,
            activityIcon: lead.activityIcon,
            status: lead.status,
            followupDate: this.formatDate(lead.followupDate),
            followupTime: this.formatTime(lead.followupTime),
            timeZone: lead.timeZone,
            nextAction: lead.nextAction,
            reminderMessage: lead.reminderMessage,
            type: lead.type,
            typeMessage: lead.typeMessage,
            salesPerson: lead.salesPerson,
            customerAddress: lead.customerAddress,
            updatedBy: lead.updatedBy,
            previousActivityId: lead.previousActivityId,
            followUpDateTime: lead.followUpDateTime,
            customerName: lead.customerName,
            templateId: lead.templateId,
            lastStatusUpdatedDate: lead.lastStatusUpdatedDate,
            lat: lead.lat,
            longitutde: lead.longitutde,
            scheduledDate: lead.scheduledDate,
            scheduledDateTime: lead.scheduledDateTime,
            startDateTime: lead.startDateTime,
            endDateTime: lead.endDateTime,
            isCompleted: lead.isCompleted,
            callType: lead.callType,
            dueDate: this.formatDate(lead.dueDate || lead.followupDate),
            dueTime: this.formatTime(lead.dueTime || lead.followupTime),
            taskType: lead.taskType,
            saveType: lead.saveType == undefined ? 1 : lead.saveType,
            completedDate: this.formatDate(lead.completedDate),
            completedTime: this.formatTime(lead.completedTime),
            completedDateTime: lead.completedDateTime,
            dueDateTime: lead.dueDateTime,
            operationType: lead.operationType,
            leadTransferMessage: lead.leadTransferMessage,
            callMessage: lead.callMessage,
            callOutcome: lead.callOutcome || lead.phoneCallOutcome,
            automated: lead.automated == undefined ? 0 : lead.automated,
            sequenceId: lead.sequenceId,
            stepId: lead.stepId,
            taskId: lead.taskId,
            step: lead.step,
            mailSequenceId: lead.mailSequenceId,


        })

        this.onChanges();

        // Show Duration input when outcome contains 'connected' and activity is a new Phone Call
        if (lead.activityType === 'Phone Call' && lead.callOutcome && String(lead.callOutcome).includes('Connected')) {
            this.durarationVisible = true;

        } else {
            // hide duration for other cases
            this.durarationVisible = false;
        }
    }


    private formatDate(date: any): string | null {
        if (date === null || date === undefined || date === '') {
            return null;
        }

        const d = new Date(date);
        if (isNaN(d.getTime())) {
            return null;
        }

        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();

        return `${year}-${month}-${day}`;
    }



    formatTime(timeValue: any): string | null {
        if (!timeValue) return null;
        const str = String(timeValue).trim();
        if (!str) return null;

        // Match 12-hour format e.g. "10:30 AM", "2:15:00 PM"
        const match12 = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)$/i);
        if (match12) {
            let hours = parseInt(match12[1], 10);
            const minutes = match12[2];
            const period = match12[3].toUpperCase();
            if (period === 'PM' && hours < 12) hours += 12;
            if (period === 'AM' && hours === 12) hours = 0;
            return `${String(hours).padStart(2, '0')}:${minutes}`;
        }

        // Match 24-hour format e.g. "14:30", "09:15:00"
        const match24 = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
        if (match24) {
            const hours = parseInt(match24[1], 10);
            const minutes = match24[2];
            return `${String(hours).padStart(2, '0')}:${minutes}`;
        }

        const date = new Date('2000-01-01 ' + str);
        if (!isNaN(date.getTime())) {
            return this.datePipe.transform(date, 'HH:mm');
        }

        return null;
    }

    padNumber(num: number): string {
        return (num < 10 ? '0' : '') + num;
    }



    phoneCallOutcome1: any = [
        { value: "0", viewValue: "Intersted" },
        { value: "1", viewValue: "Not Intersted" },
        { value: "2", viewValue: "Follow Up" },
    ]

    // Parse time string to Date object
    parseTime(timeString: string): string {
        // Split timeString into hours, minutes, and period (AM/PM)
        const [timePart, period] = timeString.split(' ');
        const [hours, minutes] = timePart.split(':').map(Number);

        // Convert to 24-hour format if PM
        let parsedHours = hours;
        if (period === 'PM' && hours !== 12) {
            parsedHours += 12;
        } else if (period === 'AM' && hours === 12) {
            parsedHours = 0; // Midnight
        }

        // Create and return a new Date object
        const time = new Date();
        time.setHours(parsedHours, minutes);
        return this.datePipe.transform(time, 'h:mm a');
    }

    schedule: any = [
        { value: "0", viewValue: "Follow Up" },
        { value: "1", viewValue: "Demo" },
    ]

    reminder: any = [
        { value: "15", viewValue: "15 min" },
        { value: "30", viewValue: "30 min" },
        { value: "45", viewValue: "45 min" },
        { value: "60", viewValue: "1 hr" },
    ]



    submitType() {

        this.dialogRef.close({ event: 'add', })

    }


    close() {
        this.dialogRef.close({ event: 'close' })
    }

    showActivityDetails() {
        this.showActivityDetailsSection = true;
        this.showAddTaskSection = false;
    }


    showAddTask() {
        this.showActivityDetailsSection = false;
        this.showAddTaskSection = true;
    }


    createDynamicForm(event, formGroupId) {
        if (event.isUserInput != false) {

            this.getFormArray(formGroupId);

        }

    }
    openTimeInput(input: HTMLInputElement) {
        input.showPicker?.(); // modern browsers (Chrome/Edge)
        input.click();        // fallback for others
    }



    getFormArray(formGroupId) {
        // Avoid repeated loads for the same formGroupId if we already have config
        if (!formGroupId) {
            this.regConfig = [];
            this.init = false;
            return;
        }

        if (this._lastFormGroupId && this._lastFormGroupId === formGroupId && this.regConfig && this.regConfig.length > 0) {
            // already loaded
            return;
        }

        this._lastFormGroupId = formGroupId;
        this.init = false;
        this.regConfig = [];

        this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe(
            (data) => {
                const value: any = data;
                this.regConfig = value || [];

                // If there are no fields, don't initialize the dynamic form (prevents empty form render)
                if (!this.regConfig || this.regConfig.length === 0) {
                    this.init = false;
                    return;
                }

                if (this.activityType == 'Edit') {
                    // When editing we need to load existing values first; that method
                    // will set `this.init = true` when it completes.
                    this.getAllFormValues(this.data['leadId'], this.data.leadObject.id);
                } else {
                    // Fields present and not editing — render the dynamic form
                    this.init = true;
                }
            },
            (err) => {
                console.error('Error loading dynamic form config', err);
                // On error, keep init false so empty dynamic form isn't shown
                this.regConfig = [];
                this.init = false;
            }
        );
    }




    //leadStatus

    filtereddropdownTypeList: any;

    public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

    phoneCallOutcome: FormControl = new FormControl('');

    dropdownTypeList: any;
    dropdownList: any;

    protected _onDestroy = new Subject<void>();

    // Track the last formGroupId loaded to avoid redundant fetches
    private _lastFormGroupId: any = null;

    getLeadDropDownList() {

        this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
            res => {
                this.dropdownList = res;
                // Ensure required fallback statuses exist in the dropdown list
                try {
                    // Use findIndex for robust detection (case-insensitive) and act on the list directly
                    const list = this.dropdownList || [];
                    const followupIndex = list.findIndex((it: any) => String(it.statusName || '').toLowerCase() === 'followup');
                    if (followupIndex === -1) {
                        list.push({
                            statusId: 2915,
                            statusName: 'Followup',
                            active: 1,
                            dynamicFormGroupId: 0,
                            statusColor: null,
                            type: 0,
                            sortOrder: null,
                            operationType: null
                        });
                    }

                    const completedIndex = list.findIndex((it: any) => String(it.statusName || '').toLowerCase() === 'completed');
                    if (completedIndex === -1) {
                        list.push({
                            statusId: 2916,
                            statusName: 'Completed',
                            active: 1,
                            dynamicFormGroupId: 0,
                            statusColor: null,
                            type: 0,
                            sortOrder: null,
                            operationType: null
                        });
                    }

                    // Remove any case-insensitive duplicate statusName entries from the list
                    const uniqueList: any[] = [];
                    const seenNames = new Set<string>();
                    for (const item of list) {
                        const key = String(item.statusName || '').toLowerCase().trim();
                        if (key && !seenNames.has(key)) {
                            seenNames.add(key);
                            uniqueList.push(item);
                        }
                    }
                    this.dropdownList = uniqueList;
                } catch (e) { /* ignore if response shape unexpected */ }

                if (this.activityType == 'Edit') {

                    const index = this.dropdownList.findIndex(item => String(item.statusName || '').toLowerCase() === String(this.data.leadObject.phoneCallOutcome || '').toLowerCase());

                    if (index >= 0) {

                        if (this.dropdownList[index].dynamicFormGroupId > 0) {
                            this.getFormArray(this.dropdownList[index].dynamicFormGroupId)


                        }

                    }

                } else {


                    this.firstFormGroup.get("callOutcome").setValue(this.callOutComeList[0].viewValue);
                    if (this.taskType != 4) {
                        //  this.firstFormGroup.get("phoneCallOutcome").setValue('Completed');
                    } else {


                    }

                }

                this.dropdownTypeList = this.dropdownList;
                this.filtereddropdownTypeList = this.dropdownTypeList;
            },
            error => {
            })
    }


    typeYFilter() {
        this.typeYFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.typeidYFilter();
            });
    }


    protected typeidYFilter() {
        if (!this.dropdownTypeList) {
            return;
        }
        let search = this.typeYFilterControl.value;
        if (!search) {
            this.filtereddropdownTypeList = this.dropdownTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
    }

    getAlldropdowntype() {
        this.filtereddropdownTypeList = this.dropdownTypeList;
    }

    //zone
    zone: TimezoneOption[] = TIMEZONE_ZONES;

    // kept for reference — DO NOT use inline array below; use TIMEZONE_ZONES instead
    private _zone_unused: any = [

        {
            "value": "IST",
            "label": "IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
        },
        {
            "value": "Dateline Standard Time",
            "label": "BIT - (GMT-12:00) International Date Line West"
        },
        {
            "value": "Samoa Standard Time",
            "label": "SMST - (GMT-11:00) Midway Island, Samoa"
        },
        {
            "value": "Hawaiian Standard Time",
            "label": "HAST - (GMT-10:00) Hawaii"
        },
        {
            "value": "Alaskan Standard Time",
            "label": "AK - (GMT-09:00) Alaska"
        },
        {
            "value": "Pacific Standard Time",
            "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
        },
        {
            "value": "US Mountain Standard Time",
            "label": "MST - (GMT-07:00) Arizona"
        },
        {
            "value": "Mountain Standard Time (Mexico)",
            "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
        },
        {
            "value": "Mountain Standard Time",
            "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
        },
        {
            "value": "Central Standard Time (Mexico)",
            "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
        },
        {
            "value": "Central Standard Time",
            "label": "CT - (GMT-06:00) Central Time (US and Canada)"
        },
        {
            "value": "Central America Standard Time",
            "label": "CAST - (GMT-06:00) Central America"
        },
        {
            "value": "Canada Central Standard Time",
            "label": "CCST - (GMT-06:00) Saskatchewan"
        },
        {
            "value": "US Eastern Standard Time",
            "label": "EST - (GMT-05:00) Indiana (East)"
        },
        {
            "value": "SA Pacific Standard Time",
            "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
        },
        {
            "value": "Eastern Standard Time",
            "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
        },
        {
            "value": "Central Brazilian Standard Time",
            "label": "CBST - (GMT-04:00) Manaus"
        },
        {
            "value": "SA Western Standard Time",
            "label": "SAWST - (GMT-04:00) Caracas, La Paz"
        },
        {
            "value": "Pacific SA Standard Time",
            "label": "PSAST - (GMT-04:00) Santiago"
        },
        {
            "value": "Atlantic Standard Time",
            "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
        },
        {
            "value": "Newfoundland Standard Time",
            "label": "NST - (GMT-03:30) Newfoundland and Labrador"
        },
        {
            "value": "SA Eastern Standard Time",
            "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
        },
        {
            "value": "Greenland Standard Time",
            "label": "GNST - (GMT-03:00) Greenland"
        },
        {
            "value": "E. South America Standard Time",
            "label": "ESAST - (GMT-03:00) Brasilia"
        },
        {
            "value": "Mid-Atlantic Standard Time",
            "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
        },
        {
            "value": "Cape Verde Standard Time",
            "label": "CVT - (GMT-01:00) Cape Verde Islands"
        },
        {
            "value": "Azores Standard Time",
            "label": "AZOST - (GMT-01:00) Azores"
        },
        {
            "value": "Greenwich Standard Time",
            "label": "GST - (GMT-00:00) Casablanca, Monrovia"
        },
        {
            "value": "GMT Standard Time",
            "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
        },
        {
            "value": "W. Europe Standard Time",
            "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
        },
        {
            "value": "W. Central Africa Standard Time",
            "label": "ECT - (GMT+01:00) West Central Africa"
        },
        {
            "value": "Romance Standard Time",
            "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
        },
        {
            "value": "Central European Standard Time",
            "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
        },
        {
            "value": "Central Europe Standard Time",
            "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
        },
        {
            "value": "Namibia Standard Time",
            "label": "NMST - (GMT+02:00) Windhoek"
        },
        {
            "value": "South Africa Standard Time",
            "label": "SAST - (GMT+02:00) Harare, Pretoria"
        },
        {
            "value": "Israel Standard Time",
            "label": "ISST - (GMT+02:00) Jerusalem"
        },
        {
            "value": "GTB Standard Time",
            "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
        },
        {
            "value": "FLE Standard Time",
            "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
        },
        {
            "value": "Egypt Standard Time",
            "label": "EGST - (GMT+02:00) Cairo"
        },
        {
            "value": "E. Europe Standard Time",
            "label": "EEST - (GMT+02:00) Minsk"
        },
        {
            "value": "Russian Standard Time",
            "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
        },
        {
            "value": "E. Africa Standard Time",
            "label": "EAT - (GMT+03:00) Nairobi"
        },
        {
            "value": "Arabic Standard Time",
            "label": "ARST - (GMT+03:00) Baghdad"
        },
        {
            "value": "Arab Standard Time",
            "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
        },
        {
            "value": "Iran Standard Time",
            "label": "IRST - (GMT+03:30) Tehran"
        },
        {
            "value": "Georgian Standard Time",
            "label": "GET - (GMT+04:00) Tblisi"
        },
        {
            "value": "Azerbaijan Standard Time",
            "label": "AZT - (GMT+04:00) Baku"
        },
        {
            "value": "Caucasus Standard Time",
            "label": "AMT - (GMT+04:00) Yerevan"
        },
        {
            "value": "Arabian Standard Time",
            "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
        },
        {
            "value": "Afghanistan Standard Time",
            "label": "AFT - (GMT+04:30) Kabul"
        },
        {
            "value": "Dateline Standard Time",
            "label": "BIT - (GMT-12:00) International Date Line West"
        },
        {
            "value": "Samoa Standard Time",
            "label": "SMST - (GMT-11:00) Midway Island, Samoa"
        },
        {
            "value": "Hawaiian Standard Time",
            "label": "HAST - (GMT-10:00) Hawaii"
        },
        {
            "value": "Alaskan Standard Time",
            "label": "AK - (GMT-09:00) Alaska"
        },
        {
            "value": "Pacific Standard Time",
            "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
        },
        {
            "value": "US Mountain Standard Time",
            "label": "MST - (GMT-07:00) Arizona"
        },
        {
            "value": "Mountain Standard Time (Mexico)",
            "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
        },
        {
            "value": "Mountain Standard Time",
            "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
        },
        {
            "value": "Central Standard Time (Mexico)",
            "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
        },
        {
            "value": "Central Standard Time",
            "label": "CT - (GMT-06:00) Central Time (US and Canada)"
        },
        {
            "value": "Central America Standard Time",
            "label": "CAST - (GMT-06:00) Central America"
        },
        {
            "value": "Canada Central Standard Time",
            "label": "CCST - (GMT-06:00) Saskatchewan"
        },
        {
            "value": "US Eastern Standard Time",
            "label": "EST - (GMT-05:00) Indiana (East)"
        },
        {
            "value": "SA Pacific Standard Time",
            "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
        },
        {
            "value": "Eastern Standard Time",
            "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
        },
        {
            "value": "Central Brazilian Standard Time",
            "label": "CBST - (GMT-04:00) Manaus"
        },
        {
            "value": "SA Western Standard Time",
            "label": "SAWST - (GMT-04:00) Caracas, La Paz"
        },
        {
            "value": "Pacific SA Standard Time",
            "label": "PSAST - (GMT-04:00) Santiago"
        },
        {
            "value": "Atlantic Standard Time",
            "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
        },
        {
            "value": "Newfoundland Standard Time",
            "label": "NST - (GMT-03:30) Newfoundland and Labrador"
        },
        {
            "value": "SA Eastern Standard Time",
            "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
        },
        {
            "value": "Greenland Standard Time",
            "label": "GNST - (GMT-03:00) Greenland"
        },
        {
            "value": "E. South America Standard Time",
            "label": "ESAST - (GMT-03:00) Brasilia"
        },
        {
            "value": "Mid-Atlantic Standard Time",
            "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
        },
        {
            "value": "Cape Verde Standard Time",
            "label": "CVT - (GMT-01:00) Cape Verde Islands"
        },
        {
            "value": "Azores Standard Time",
            "label": "AZOST - (GMT-01:00) Azores"
        },
        {
            "value": "Greenwich Standard Time",
            "label": "GST - (GMT-00:00) Casablanca, Monrovia"
        },
        {
            "value": "GMT Standard Time",
            "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
        },
        {
            "value": "W. Europe Standard Time",
            "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
        },
        {
            "value": "W. Central Africa Standard Time",
            "label": "ECT - (GMT+01:00) West Central Africa"
        },
        {
            "value": "Romance Standard Time",
            "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
        },
        {
            "value": "Central European Standard Time",
            "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
        },
        {
            "value": "Central Europe Standard Time",
            "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
        },
        {
            "value": "Namibia Standard Time",
            "label": "NMST - (GMT+02:00) Windhoek"
        },
        {
            "value": "South Africa Standard Time",
            "label": "SAST - (GMT+02:00) Harare, Pretoria"
        },
        {
            "value": "Israel Standard Time",
            "label": "ISST - (GMT+02:00) Jerusalem"
        },
        {
            "value": "GTB Standard Time",
            "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
        },
        {
            "value": "FLE Standard Time",
            "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
        },
        {
            "value": "Egypt Standard Time",
            "label": "EGST - (GMT+02:00) Cairo"
        },
        {
            "value": "E. Europe Standard Time",
            "label": "EEST - (GMT+02:00) Minsk"
        },
        {
            "value": "Russian Standard Time",
            "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
        },
        {
            "value": "E. Africa Standard Time",
            "label": "EAT - (GMT+03:00) Nairobi"
        },
        {
            "value": "Arabic Standard Time",
            "label": "ARST - (GMT+03:00) Baghdad"
        },
        {
            "value": "Arab Standard Time",
            "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
        },
        {
            "value": "Iran Standard Time",
            "label": "IRST - (GMT+03:30) Tehran"
        },
        {
            "value": "Georgian Standard Time",
            "label": "GET - (GMT+04:00) Tblisi"
        },
        {
            "value": "Azerbaijan Standard Time",
            "label": "AZT - (GMT+04:00) Baku"
        },
        {
            "value": "Caucasus Standard Time",
            "label": "AMT - (GMT+04:00) Yerevan"
        },
        {
            "value": "Arabian Standard Time",
            "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
        },
        {
            "value": "Afghanistan Standard Time",
            "label": "AFT - (GMT+04:30) Kabul"
        },
        {
            "value": "West Asia Standard Time",
            "label": "WAST - (GMT+05:00) Islamabad, Karachi, Tashkent"
        }

    ]

    convertToAMPMFormat(time: string, minutesAdjustment?: number): string {
        if (time != null && time !== '' && time !== undefined) {
            const timeStr = String(time).trim();
            if (/(AM|PM)$/i.test(timeStr)) {
                return timeStr;
            }

            const [hoursStr, minutesStr] = timeStr.split(':');
            if (!hoursStr || !minutesStr) {
                return timeStr;
            }

            let hours = parseInt(hoursStr, 10);
            let minutes = parseInt(minutesStr, 10);

            if (isNaN(hours) || isNaN(minutes)) {
                return timeStr;
            }

            const meridiem = hours >= 12 ? 'PM' : 'AM';
            let hours12 = hours % 12;
            hours12 = hours12 || 12;

            return `${hours12}:${minutes.toString().padStart(2, '0')} ${meridiem}`;
        } else {
            return null;
        }
    }

    isGivenTimeGreaterThanCurrentTime(givenTime: string, givenDate: any): boolean {
        if (!givenTime || !givenDate) {
            return false;
        }
        try {
            const d = new Date(givenDate);
            if (isNaN(d.getTime())) {
                return false;
            }

            let hours = 0;
            let minutes = 0;
            const timeStr = String(givenTime).trim();
            const match12 = timeStr.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)$/i);
            if (match12) {
                hours = parseInt(match12[1], 10);
                minutes = parseInt(match12[2], 10);
                const period = match12[3].toUpperCase();
                if (period === 'PM' && hours < 12) hours += 12;
                if (period === 'AM' && hours === 12) hours = 0;
            } else {
                const match24 = timeStr.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
                if (match24) {
                    hours = parseInt(match24[1], 10);
                    minutes = parseInt(match24[2], 10);
                }
            }

            const target = new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours, minutes, 0, 0);
            const now = new Date();

            return target.getTime() > now.getTime();
        } catch (e) {
            return false;
        }
    }

    onFormSubmitted(event) {
        const rawVal = this.firstFormGroup.getRawValue();
        const dynamicArray: any[] = [];

        if (event && typeof event === 'object') {
            Object.entries(event).forEach(([key, value]) => {
                if (value != null && value != undefined) {
                    let indexFieldId = this.regConfig.findIndex(item => item.name === key);
                    let entityId = 0;
                    if (this.activityType == 'Edit') {
                        let indexEntityId = this.simpleFormValueList.findIndex(item => item.fieldId === this.regConfig[indexFieldId]?.fieldId);
                        if (indexEntityId >= 0) {
                            entityId = this.simpleFormValueList[indexEntityId].entityId;
                        }
                    }
                    if (indexFieldId >= 0) {
                        let object = {
                            entityId: entityId,
                            fieldId: this.regConfig[indexFieldId].fieldId,
                            leadId: rawVal.leadId,
                            fieldValue: value,
                            activityId: this.activityType == 'Edit' ? this.data.leadObject?.id : 0
                        };
                        dynamicArray.push(object);
                    }
                }
            });
        }

        this.firstFormGroup.value.dynamicFieldValues = dynamicArray;

        if (this.type == 2) {
            this.save();
        }
    }

    submit() {
        if (this.regConfig.length > 0) {
            this.type = 2;
            if (this.simpleDynamicFormComponent && typeof this.simpleDynamicFormComponent.onSubmit === 'function') {
                this.simpleDynamicFormComponent.onSubmit();
            } else {
                this.init = true;
                this.cdr.detectChanges();
                setTimeout(() => {
                    if (this.simpleDynamicFormComponent && typeof this.simpleDynamicFormComponent.onSubmit === 'function') {
                        this.simpleDynamicFormComponent.onSubmit();
                    } else {
                        this.save();
                    }
                }, 50);
            }
        } else {
            this.save();
        }
    }

    save() {
        const rawVal = this.firstFormGroup.getRawValue();

        if (rawVal.dueTime != null && rawVal.dueTime != '') {
            const time = rawVal.dueTime;
            if (time && !/(AM|PM)$/i.test(time)) {
                const formattedTime = this.convertToAMPMFormat(time);
                this.firstFormGroup.get('followupTime')?.setValue(formattedTime);
                this.firstFormGroup.get("dueTime")?.setValue(formattedTime);
            } else {
                this.firstFormGroup.get('followupTime')?.setValue(time);
            }
            this.firstFormGroup.get('followupDate')?.setValue(rawVal.dueDate);
        }

        const outcomeVal = rawVal.phoneCallOutcome || rawVal.callOutcome;
        const isOutcomeCompleted = outcomeVal && (
            String(outcomeVal).toLowerCase() === 'completed' ||
            String(outcomeVal).toLowerCase() === 'complete'
        );

        if (this.taskType == 1) {
            if (rawVal.followupDate) {
                this.firstFormGroup.get('dueDate')?.setValue(rawVal.followupDate);
            }
            if (rawVal.followupTime) {
                this.firstFormGroup.get('dueTime')?.setValue(rawVal.followupTime);
            }
            if (rawVal.dueDate && !rawVal.followupDate) {
                this.firstFormGroup.get('followupDate')?.setValue(rawVal.dueDate);
            }
            if (rawVal.dueTime && !rawVal.followupTime) {
                this.firstFormGroup.get('followupTime')?.setValue(rawVal.dueTime);
            }

            if (outcomeVal === 'Followup' || outcomeVal === 'Demo' || outcomeVal === 'Payment Followup') {
                this.firstFormGroup.get('followupDate')?.setValidators([Validators.required]);
                this.firstFormGroup.get('followupTime')?.setValidators([Validators.required]);
            } else {
                this.firstFormGroup.get('followupDate')?.clearValidators();
                this.firstFormGroup.get('followupTime')?.clearValidators();
            }
            this.firstFormGroup.get('dueDate')?.clearValidators();
            this.firstFormGroup.get('dueTime')?.clearValidators();
        } else if (this.taskType == 3 || isOutcomeCompleted) {
            this.firstFormGroup.get('dueDate')?.clearValidators();
            this.firstFormGroup.get('dueTime')?.clearValidators();
            this.firstFormGroup.get('followupDate')?.clearValidators();
            this.firstFormGroup.get('followupTime')?.clearValidators();
        } else if (this.taskType == 2) {
            this.firstFormGroup.get('dueDate')?.setValidators([Validators.required]);
            this.firstFormGroup.get('dueTime')?.setValidators([Validators.required]);
        } else if (outcomeVal === 'Followup' || outcomeVal === 'Demo' || outcomeVal === 'Payment Followup') {
            this.firstFormGroup.get('followupDate')?.setValidators([Validators.required]);
            this.firstFormGroup.get('followupTime')?.setValidators([Validators.required]);
            this.firstFormGroup.get('dueDate')?.setValidators([Validators.required]);
            this.firstFormGroup.get('dueTime')?.setValidators([Validators.required]);
        }

        this.firstFormGroup.get('dueDate')?.updateValueAndValidity();
        this.firstFormGroup.get('dueTime')?.updateValueAndValidity();
        this.firstFormGroup.get('followupDate')?.updateValueAndValidity();
        this.firstFormGroup.get('followupTime')?.updateValueAndValidity();

        if (!this.firstFormGroup.valid) {
            this.firstFormGroup.markAllAsTouched();
        }

        if (this.text == 'Save' && this.firstFormGroup.valid) {
            const currentRaw = this.firstFormGroup.getRawValue();

            if (this.taskType == 2) {
                this.dueTime = currentRaw.dueTime;
            } else if (this.taskType == 1) {
                this.dueTime = currentRaw.followupTime;
            }

            if (currentRaw.id > 0) {
                this.firstFormGroup.get("operationType")?.setValue("Change");
            } else {
                this.firstFormGroup.get("operationType")?.setValue("New");
            }

            this.text = "Processing";
            let result = true;

            if (this.taskType == 3) {
                this.firstFormGroup.get("status")?.setValue(1);
                this.firstFormGroup.get("phoneCallOutcome")?.setValue("Completed");
                this.firstFormGroup.get("callOutcome")?.setValue("Completed");
                this.firstFormGroup.get("isCompleted")?.setValue(1);
                let value = this.convertToAMPMFormat(currentRaw.followupTime);
                result = this.isGivenTimeGreaterThanCurrentTime(value, currentRaw.followupDate);
                this.firstFormGroup.get("followupTime")?.setValue(value);
                let dueTime = this.convertToAMPMFormat(currentRaw.dueTime);
                this.firstFormGroup.get("dueTime")?.setValue(dueTime);
                this.firstFormGroup.get("completedDate")?.setValue(null);

                this.saveActivity();
            } else if (
                currentRaw.activityType == 'Follow Up'
                || currentRaw.activityType == 'Call reminder'
                || currentRaw.activityType == 'Demo'
                || currentRaw.activityType == 'Payment Followup'
                || currentRaw.phoneCallOutcome == 'Followup'
                || currentRaw.phoneCallOutcome == 'Demo'
                || currentRaw.phoneCallOutcome == 'Payment Followup') {

                if (currentRaw.id == 0 && currentRaw.dueTime != '') {
                    let value = this.convertToAMPMFormat(currentRaw.followupTime);
                    result = this.isGivenTimeGreaterThanCurrentTime(value, currentRaw.followupDate);
                    this.firstFormGroup.get("status")?.setValue(0);
                    this.firstFormGroup.get("followupTime")?.setValue(value);

                    let dueTime = this.convertToAMPMFormat(currentRaw.dueTime);
                    this.firstFormGroup.get("dueTime")?.setValue(dueTime);
                } else if (currentRaw.id == 0) {
                    if (currentRaw.followupTime != null && currentRaw.followupTime !== '') {
                        let value = this.convertToAMPMFormat(currentRaw.followupTime);
                        result = this.isGivenTimeGreaterThanCurrentTime(currentRaw.followupTime, currentRaw.followupDate);
                        this.firstFormGroup.get("followupTime")?.setValue(value);
                    }
                    this.firstFormGroup.get("status")?.setValue(0);
                } else {
                    if (this.originalValue != null) {
                        this.firstFormGroup.value.status = 1;
                        this.firstFormGroup.value.followupTime = this.originalValue;
                        this.firstFormGroup.get("followupTime")?.setValue(this.originalValue);
                    }
                }

                if (result) {
                    this.saveActivity();
                } else {
                    if (this.dueTime != null && this.dueTime != '') {
                        if (this.taskType == 1) {
                            this.firstFormGroup.get("followupTime")?.setValue(this.dueTime);
                        } else if (this.taskType == 2) {
                            this.firstFormGroup.get("dueTime")?.setValue(this.dueTime);
                        }
                    }
                    this.text = "Save";
                    this.snackBar.open('Follow Up Cannot Be Schedule For Given Time!', 'X', {
                        duration: 3000,
                        verticalPosition: 'bottom',
                        panelClass: ['error'],
                    });
                }
            } else {
                this.saveActivity();
            }
        } else {
            this.firstFormGroup.markAllAsTouched();
        }
    }

    getAllFormValues(leadId, activityId) {

        this.dynamicFieldValueService.getALLFieldValues(leadId, activityId).subscribe(
            res => {

                this.simpleFormValueList = res;
                this.init = true;
            },
            error => {
            }
        )
    }

    getValue(event) {

        this.firstFormGroup.get('schedule').setValue(event);

    }

    //whatsapp template


    WhatsappTemplateMessageList: any;
    filteredWhatsappTemplateMessageTypeList: any;

    public WhatsappTemplateMessageFilterControl: UntypedFormControl = new UntypedFormControl();

    getWhatsappTemplateMessageList() {
        this.whatsapptemplatemessageService.getAllWhatsapptemplatemessageDropDown().subscribe(
            (res) => {
                this.WhatsappTemplateMessageList = res;
                this.WhatsappTemplateMessageList = this.WhatsappTemplateMessageList;
                this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList;
            },
            (error) => { }
        );
    }

    WhatsappTemplateMessageYFilter() {
        this.WhatsappTemplateMessageFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.WhatsappTemplateMessageFilter();
            });
    }

    protected WhatsappTemplateMessageFilter() {
        if (!this.WhatsappTemplateMessageList) {
            return;
        }
        let search = this.WhatsappTemplateMessageFilterControl.value;
        if (!search) {
            this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList.filter(
            (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
        );
    }

    getAllWhatsappTemplateMessage() {
        this.filteredWhatsappTemplateMessageTypeList = this.WhatsappTemplateMessageList;
    }

    async getAddressFromLatLng(lat: number, lng: number) {
        try {
            await this.googleMapService.load(this.apiKey); // Replace with actual key

            if (!google || !google.maps || !google.maps.Geocoder) {
                console.error('Google Maps not available');
                return;
            }

            this.textmap = 'Fetching address...';

            const geocoder = new google.maps.Geocoder();
            const latlng = { lat: parseFloat(lat as any), lng: parseFloat(lng as any) };

            geocoder.geocode({ location: latlng }, (results, status) => {
                this.textmap = "Get Current Location";
                if (status === 'OK') {
                    if (results[1] || results[0]) {
                        const address = results[1]?.formatted_address || results[0].formatted_address;
                        this.firstFormGroup.patchValue({ customerAddress: address });
                    } else {
                        console.warn('No address found');
                    }
                } else {
                    console.error('Geocoder failed due to:', status);
                }
            });
        } catch (error) {
            this.textmap = "Get Current Location";
            console.error('Error loading Google Maps:', error);
        }
    }

    googleMapsLoaded = false;

    ngAfterViewInit() {

        if (this.enableLocation == 1) {
            this.getUserLocation();
        }


        if (typeof google !== 'undefined' && google.maps) {
            this.googleMapsLoaded = true;
            //      this.initMap();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places&loading=async&callback=initMapCallback`;
        script.async = true;
        script.defer = true;
        window['initMapCallback'] = () => {
            this.googleMapsLoaded = true;
            //   this.initMap();
        };
        document.body.appendChild(script);
    }

    getConfigData() {
        const encryptedData = localStorage.getItem('configSettingsData');
        if (encryptedData) {
            try {
                const decrypted = this.ecryptService.decryptionAES(encryptedData);
                const data = JSON.parse(decrypted);
                this.apiKey = data['googleApi'];

            }
            catch (error) {
                console.error("Failed to decrypt crmSettingsData:", error);
            }
        }
    }

    getUserLocation() {
        const options = {
            maximumAge: 0,
            timeout: 3000,
            enableHighAccuracy: true
        };

        navigator.geolocation.getCurrentPosition(
            (resp) => {
                this.textmap = "Please wait... ";
                setTimeout(() => {
                    this.getAddressFromLatLng(resp.coords.latitude, resp.coords.longitude)
                }, 500);

            },
            (error) => {
                console.error('Error getting location', error);
            },
            options
        );

    }

    onNotesChange(value: string) {

        if (this.taskType == 1) {
            if (value.length > 0) {
                this.initNotes = false;
            }
            else if (value.length < 1) {
                this.initNotes = true;
            }
            else {

            }
        }

    }


    saveActivity() {

        if (this.activityType != 'Edit') {
            this.firstFormGroup.patchValue({
                taskType: this.data.taskSaveType
            });
        }

        const rawStatus = this.firstFormGroup.getRawValue().status;
        if (rawStatus === true || rawStatus === 1) {
            this.firstFormGroup.get("status")?.setValue(1);
        } else if (rawStatus === false || rawStatus === 0) {
            this.firstFormGroup.get("status")?.setValue(0);
        }

        this.firstFormGroup.get("saveType")?.setValue(this.taskType);

        const payload = this.firstFormGroup.getRawValue();

        this.leadActivityService.addOrEditLeadActivity(payload).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.text = "Save";
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.submitType();
                }
                else {
                    this.firstFormGroup.get("followupTime")
                        ?.setValue(this.followUpNewTime);
                    this.text = "Save";
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => { this.text = "Save"; });
    }

    callOutComeList: any = [
        { value: "No Answer", viewValue: "No Answer" },
        { value: "Left Voicemail", viewValue: "Left Voicemail" },
        { value: "Busy", viewValue: "Busy" },
        { value: "Gatekeeper", viewValue: "Gatekeeper" },
        { value: "Bad / Wrong Number", viewValue: "Bad / Wrong Number" },
        { value: "Not in Service", viewValue: "Not in Service" },
        { value: "Connected - Positive", viewValue: "Connected - Positive" },
        { value: "Connected - Neutral", viewValue: "Connected - Neutral" },
        { value: "Connected - Negative", viewValue: "Connected - Negative" }
    ]
    //callOutcome

    defaultLeadStatus: FormControl = new FormControl('');
    filteredCallOutcomeTypeList: any = [];
    dropdownCallOutcomeTypeList: any = [];
    dropdownCallOutcomeList: any = [];
    public typeCallOutcomeFilterControl: UntypedFormControl = new UntypedFormControl();

    getCallOutcomeDropDownList() {

        this.callOutcomeService.getAllCallOutcomeDropDown(11).subscribe(
            res => {
                const list = Array.isArray(res) ? res : (res && Array.isArray((res as any).data) ? (res as any).data : []);
                this.dropdownCallOutcomeList = list;
                this.dropdownCallOutcomeTypeList = list;
                this.filteredCallOutcomeTypeList = list;
            },
            error => {
            })
    }


    typeCallOutcomeYFilter() {
        this.typeCallOutcomeFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.typeCallOutcomeidYFilter();
            });
    }


    protected typeCallOutcomeidYFilter() {
        if (!this.dropdownCallOutcomeTypeList || !Array.isArray(this.dropdownCallOutcomeTypeList)) {
            this.filteredCallOutcomeTypeList = [];
            return;
        }
        let search = this.typeCallOutcomeFilterControl.value;
        if (!search) {
            this.filteredCallOutcomeTypeList = this.dropdownCallOutcomeTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredCallOutcomeTypeList = this.dropdownCallOutcomeTypeList.filter(status => status && status['statusName'] && status['statusName'].toLowerCase().indexOf(search) > -1);
    }

    getAllCallOutcomedropdowntype() {
        this.filteredCallOutcomeTypeList = Array.isArray(this.dropdownCallOutcomeTypeList) ? this.dropdownCallOutcomeTypeList : [];
    }


    sanitizeUrl(u: string): string {
        return (u || '')
            .replace(/^\/+/, '')
            .replace(/[?#&=]/g, '-')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
